import { render } from "./IconEyeClosed.vue?vue&type=template&id=68606572"
const script = {}

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__